import Admin from 'hive-admin';

// eslint-disable-next-line max-len
import FilterPagination from 'hive-admin/src/components/FilterPagination';

Admin.addToLibrary('FilterPagination', (config = {}) => (
  // eslint-disable-next-line max-len
  FilterPagination.create({
    ...config,
    defaultPageSize: 20,
  })
));
